<svg
    viewBox="0 0 140 160"
    role="img"
    [attr.aria-label]="'Teilnahmeabzeichen Saison ' + seasonNumber"
>
    <defs>
        <linearGradient [attr.id]="'badge-accent-' + uid" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" [attr.stop-color]="accentLight" />
            <stop offset="1" [attr.stop-color]="accentDark" />
        </linearGradient>
        <linearGradient [attr.id]="'badge-panel-' + uid" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#334155" />
            <stop offset="1" stop-color="#0f172a" />
        </linearGradient>
        <linearGradient [attr.id]="'badge-gold-' + uid" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#fde68a" />
            <stop offset="1" stop-color="#d97706" />
        </linearGradient>
        <linearGradient [attr.id]="'badge-frame-gold-' + uid" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#fef3c7" />
            <stop offset="0.5" stop-color="#facc15" />
            <stop offset="1" stop-color="#b45309" />
        </linearGradient>
        <linearGradient [attr.id]="'badge-ribbon-gold-' + uid" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#fde68a" />
            <stop offset="1" stop-color="#f59e0b" />
        </linearGradient>
        <filter [attr.id]="'badge-glow-' + uid" x="-30%" y="-30%" width="160%" height="160%">
            <feDropShadow dx="0" dy="0" stdDeviation="3" flood-color="#fbbf24" flood-opacity="0.9" />
        </filter>
        <clipPath [attr.id]="'badge-clip-' + uid">
            <path d="M70 15 L116 29 V80 C116 105 99 126 70 144 C41 126 24 105 24 80 V29 Z" />
        </clipPath>
        <path
            [attr.id]="'badge-leaf-' + uid"
            d="M0 0 C4 -3.5 9.5 -3.5 13 0 C9.5 3.5 4 3.5 0 0 Z"
        />
    </defs>

    <!-- Outer shield (accent, or gold + glow for a 100% season) -->
    <path
        d="M70 6 L124 22 V80 C124 110 104 134 70 154 C36 134 16 110 16 80 V22 Z"
        [attr.fill]="complete ? 'url(#badge-frame-gold-' + uid + ')' : 'url(#badge-accent-' + uid + ')'"
        [attr.filter]="complete ? 'url(#badge-glow-' + uid + ')' : null"
        stroke="#00000033"
        stroke-width="1"
    />
    <!-- Inner panel -->
    <path
        d="M70 15 L116 29 V80 C116 105 99 126 70 144 C41 126 24 105 24 80 V29 Z"
        [attr.fill]="'url(#badge-panel-' + uid + ')'"
    />

    <!-- Checkered band -->
    <g [attr.clip-path]="'url(#badge-clip-' + uid + ')'">
        <rect x="24" y="29" width="92" height="16" fill="#f8fafc" />
        <g fill="#0f172a">
            <rect x="24" y="29" width="8" height="8" /><rect x="40" y="29" width="8" height="8" />
            <rect x="56" y="29" width="8" height="8" /><rect x="72" y="29" width="8" height="8" />
            <rect x="88" y="29" width="8" height="8" /><rect x="104" y="29" width="8" height="8" />
            <rect x="32" y="37" width="8" height="8" /><rect x="48" y="37" width="8" height="8" />
            <rect x="64" y="37" width="8" height="8" /><rect x="80" y="37" width="8" height="8" />
            <rect x="96" y="37" width="8" height="8" /><rect x="112" y="37" width="8" height="8" />
        </g>
        <!-- Sheen -->
        <path d="M24 15 L116 29 L116 52 L24 66 Z" fill="#ffffff" opacity="0.06" />
    </g>

    <!-- Laurel branches -->
    <g [attr.fill]="'url(#badge-gold-' + uid + ')'">
        <g>
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(31 121) rotate(-25)" />
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(27 108) rotate(-50)" />
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(26 94) rotate(-72)" />
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(29 80) rotate(-88)" />
        </g>
        <g transform="translate(140 0) scale(-1 1)">
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(31 121) rotate(-25)" />
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(27 108) rotate(-50)" />
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(26 94) rotate(-72)" />
            <use [attr.href]="'#badge-leaf-' + uid" transform="translate(29 80) rotate(-88)" />
        </g>
    </g>

    <!-- Texts -->
    <text
        x="70"
        y="66"
        text-anchor="middle"
        font-size="12"
        font-weight="600"
        letter-spacing="3"
        fill="#e2e8f0"
        opacity="0.9"
    >
        SAISON
    </text>
    <text
        class="badge-number"
        x="70"
        [attr.y]="numberY"
        text-anchor="middle"
        [attr.font-size]="numberFontSize"
        fill="#ffffff"
    >
        {{ seasonNumber }}
    </text>

    <!-- 100% ribbon replaces the footer on a perfect season -->
    @if (complete) {
        <polygon points="42,114 34,118 34,127 42,131" fill="#92400e" />
        <polygon points="98,114 106,118 106,127 98,131" fill="#92400e" />
        <rect
            x="42"
            y="114"
            width="56"
            height="17"
            rx="1.5"
            [attr.fill]="'url(#badge-ribbon-gold-' + uid + ')'"
            stroke="#7c2d12"
            stroke-width="0.5"
        />
        <text
            x="70"
            y="126.5"
            text-anchor="middle"
            font-size="11"
            font-weight="800"
            letter-spacing="0.5"
            fill="#7c2d12"
        >
            100%
        </text>
    } @else {
        <text
            x="70"
            y="132"
            text-anchor="middle"
            font-size="7"
            font-weight="600"
            letter-spacing="1.5"
            fill="#94a3b8"
        >
            BPV RACING
        </text>
    }
</svg>
